import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import { amaPageBasePath, storylinesPageUrl, userPageBasePath } from '@ms/yammer-web-support/dist/urls';
import { useCallback, useMemo } from 'react';

import { usePageUrlClick } from '../../../navigation/SubHeader/hooks/usePageUrlClick';
import { VivaEngageNavigationHeaderPivotItem } from '../types';

type UseStorylinesPivotItem = () => VivaEngageNavigationHeaderPivotItem;
export const useStorylinesPivotItem: UseStorylinesPivotItem = () => {
  const t = useTranslations(NavigationStrings);
  const onPageUrlClick = usePageUrlClick();
  const reportAndRedirectToStorylinesPage = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.StorylinesTabClicked,
    });
    onPageUrlClick(storylinesPageUrl);
  }, [onPageUrlClick]);

  return useMemo(
    () => ({
      key: '/storylines',
      supportedRoutes: [userPageBasePath, amaPageBasePath],
      onClick: reportAndRedirectToStorylinesPage,
      text: t.appNavigationStorylines(),
    }),
    [reportAndRedirectToStorylinesPage, t]
  );
};
